<div class="modal-header">
  <h4 class="modal-title">{{'editProject.title.edit' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-5 col-form-label">{{'editProject.label.name' | translate}}: </label>
        <div class="col-md-7">
          <input type="text" class="form-control" (keydown.enter)="onSave()"
                 [class.is-invalid]="!form.controls[projectNameFormItemName].valid"
                 formControlName="{{projectNameFormItemName}}"
                 appInputAutoFocus autofocus>
          <div class="invalid-feedback">{{form.controls[projectNameFormItemName].errors?.messageKey | translate: {'0': form.controls[projectNameFormItemName].errors?.param} }}</div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="onCancel()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" (click)="onSave()">{{'global.label.save' | translate}}</button>
</div>
